import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { Table } from 'reactstrap';

import { ROUTES, insertCustomSurveyIdtoUrl } from 'constants/Routes.js';

class CustomSurveyList extends Component {
  constructor() {
    super();
    this.state = {
      searchText: '',
    };
  }

  onChange = e => {
    const { value } = e.target;
    this.setState({ searchText: value });
  };

  getNavUrl = id => {
    const { match } = this.props;
    const { params } = match;
    const { id: businessId } = params;

    const navUrl = insertCustomSurveyIdtoUrl(
      ROUTES.CUSTOM_SURVEY_QUESTIONS,
      businessId,
      id
    );
    return navUrl;
  };

  render() {
    const { customSurveys } = this.props;
    const { searchText } = this.state;
    const filteredSurveys = customSurveys.filter(
      ({ name }) =>
        name && name.toLowerCase().includes(searchText.toLowerCase())
    );
    const customSurveyList = filteredSurveys.map(({ id, name }) => {
      return (
        <tr key={id}>
          <td>
            <NavLink to={this.getNavUrl(id)} activeClassName="navActive">
              {name || 'Survey'}
            </NavLink>
          </td>
        </tr>
      );
    });

    return (
      <Table
        hover
        className="styled-box-shadow left-nav-box"
        id="questionsTable"
      >
        <thead>
          <tr>
            <th>Soono Surveys</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>
              <input
                className="form-control bg-light"
                type="search"
                placeholder="Search"
                onChange={this.onChange}
              />
            </th>
          </tr>
          {customSurveyList}
        </tbody>
      </Table>
    );
  }
}

CustomSurveyList.defaultProps = {
  customSurveys: [],
};

CustomSurveyList.propTypes = {
  customSurveys: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }).isRequired,
};

export default withRouter(CustomSurveyList);



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/questions/CustomSurveyList.js